<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/mKnPhs/images/emily-climbs-ebook-cover-final.jpg?1731411248211" alt="This image is the cover for the book Emily Climbs"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Emily Climbs
      </h1>
      <p class="bookDescription body article font2">
        <p>The Sequel to the Classic Emily of New Moon    Emily Byrd Starr must write—burns to write. She writes out her problems and pours out her dreams, spins stories and poems from flashes of insight. Writing sustained her through the loss of her father and sustains her now despite family disapproval.    Though she’s found a home at New Moon Farm with her aunts and cousin, and dear friends in quiet Blair Water, she knows she needs more if she’s ever going to make her mark on the world. She dreads the coming years, left behind when her friends go away to school. Then Aunt Elizabeth offers her a chance to go with them—and demands an unbearable sacrifice.    Can she give up her writing—or her beloved home—to further her ambition?    Follow along with Emily, in her own words, as she grows from girl to young woman, balancing tradition and discovery. In this fine new edition, with new foreword by Canadian scholar Dr. E. Holly Pike, find out why Emily Climbs, like author L.M. Montgomery’s most famous series about Anne of Green Gables, has never gone out of print</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        L. M. Montgomery, Mel Heath Johnson, Holly Pike
      </h2>
      
      <p class="authorDescription body article">L. M. Montgomery (1874&ndash;1942) published her first short story at age fifteen. Her debut novel,&#160;<I>Anne of Green Gables</I>, was an immediate success and allowed Montgomery to leave her career as a schoolteacher and devote herself to writing. She went on to publish seven sequels starring Anne Shirley and numerous other novels, short stories, and essays.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      WordFire Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?65dc7944